import { useLocation } from "react-router-dom";
import { useTheme } from "styled-components";
import { HeaderSection, HeaderElement, PageHeader } from "./Header.styled";
import { Container } from "assets/styles/Layout/Layout.styled";
import Navmenu from "./Navmenu/Navmenu";

import HomePage from "components/Header/PageHeader/HomePage/index";
import Diensten from "components/Header/PageHeader/Diensten/index";
import OverOns from "components/Header/PageHeader/OverOns/index";
import WerkenBij from "components/Header/PageHeader/WerkenBij/index";
import Contact from "components/Header/PageHeader/Contact/index";

import home from "assets/images/home.jpg";
import diensten from "assets/images/diensten.jpg";
import overons from "assets/images/over-ons.jpg";
import werkenbij from "assets/images/werken-bij.jpg";
import contact from "assets/images/contact.jpg";


function Header() {
  const path          = useLocation().pathname,
        theme         = useTheme(),

        pageHeader    = () => {
          if (path === "/") return <HomePage />;
          if (path === "/diensten") return <Diensten />;
          if (path === "/over-ons") return <OverOns />;
          if (path === "/werken-bij") return <WerkenBij />;
          if (path === "/contact") return <Contact />;
        },

        sectionBg     = () => {
          if (path === "/") return home;
          if (path === "/diensten") return diensten;
          if (path === "/over-ons") return overons;
          if (path === "/werken-bij") return werkenbij;
          if (path === "/contact") return contact;
        },

        sectionHeight = () => path === "/" ? 100 : 80,
        navmenuBg     = () => path !== "/" ? theme.colors.navmenuBg : '';     

  return (
    <HeaderSection bg={sectionBg()} sectionHeight={sectionHeight()}>

      <HeaderElement navmenuBg={navmenuBg()}>
        <Container>
          <Navmenu />
          {path === "/" && <hr />}
        </Container>
      </HeaderElement>

      <Container marginTop={70}>
        <PageHeader>
          {pageHeader()}
        </PageHeader>
      </Container>

    </HeaderSection>
  );
}

export default Header;
